export const messages = {
  en: {
    mainCategory: {
      queryCondition: 'Query Conditions',
      productCategory: 'Product Category',
      categoryId: 'Category ID',
      categoryName: 'Category Name',
      startTime: 'Start Time',
      endTime: 'End Time',
      seq: 'Sequence',
      desc: 'Description',
      status: 'Status',
      status0: 'Enabled',
      status1: 'Disabled',
      enable: 'Enable',
      disable: 'Disable',
      confirmEnable: 'Are you sure to enable this category?',
      confirmDisable: 'Are you sure to disable this category?',
      confirm: 'Confirm',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      query: 'Query',
      cancel: 'Cancel',
      save: 'Save',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteCategory: 'Are you sure to delete this category?',
      confirmDelete: 'Confirm Delete',
      editCategory: 'Edit Product Category',
      inputCategoryName: 'Please input category name',
      inputCategoryId: 'Please input category ID',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      inputSeq: 'Please input sequence',
      inputDesc: 'Please input description',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully',
      categoryNameRequired: 'Category name is required',
      categoryNameTooLong: 'Category name is too long',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      seqRequired: 'Sequence is required',
      seqMustNumber: 'Sequence must be a number',
      descRequired: 'Description is required',
      descTooLong: 'Description is too long'
    }
  },
  zh: {
    mainCategory: {
      queryCondition: '查询条件',
      productCategory: '商品目录',
      categoryId: '目录编号',
      categoryName: '目录名称',
      startTime: '开始时间',
      endTime: '结束时间',
      seq: '排序',
      desc: '描述',
      status: '状态',
      status0: '启用',
      status1: '禁用',
      enable: '启用',
      disable: '禁用',
      confirmEnable: '确定要启用该目录吗？',
      confirmDisable: '确定要禁用该目录吗？',
      confirm: '确定',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      query: '查询',
      cancel: '取消',
      save: '保存',
      confirmOperation: '请确认您的操作',
      confirmDeleteCategory: '确定删除商品目录吗？',
      confirmDelete: '确认删除',
      editCategory: '修改商品目录',
      inputCategoryName: '请输入目录名称',
      inputCategoryId: '请输入目录编号',
      selectStartTime: '请选择开始时间',
      selectEndTime: '请选择结束时间',
      inputSeq: '请输入排序',
      inputDesc: '请输入描述',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      categoryNameRequired: '目录名称不能为空',
      categoryNameTooLong: '目录名称太长',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      seqRequired: '排序不能为空',
      seqMustNumber: '排序必须是数字',
      descRequired: '描述不能为空',
      descTooLong: '描述太长'
    }
  }
}